import actionTypes from '../constants/action-types';

const setDisabledStatus = (value) => ({
  type: actionTypes.SET_DISABLED_STATUS,
  payload: value,
});

export default setDisabledStatus;
